import { render, staticRenderFns } from "./JVxeDateCell.vue?vue&type=template&id=2912bc06&scoped=true"
import script from "./JVxeDateCell.vue?vue&type=script&lang=js"
export * from "./JVxeDateCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2912bc06",
  null
  
)

export default component.exports